export default {
  name: "ServiceProvider",
  props: {
    providers: {
      type: Array,
      default: () => [],
    }
  }
};
